import { createSelector } from '@ngrx/store'

export const getLicenseTypesState = createSelector(
  (state: any) => state.licenseTypes,
  (state: any) => state.get('list'),
)

export const getCreateLicenseTypeState = createSelector(
  (state: any) => state.licenseTypes,
  (state: any) => state.get('createLicenseType'),
)

export const getUpdateLicenseTypeState = createSelector(
  (state: any) => state.licenseTypes,
  (state: any) => state.get('updateLicenseType'),
)
